import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import Cart from '../Cart/Cart';
import Order from '../Order/Order';
import './Products.css'



const Products = () => {
    const [cartId , serCartId ] = useState([])
    const history = useHistory()

    const handleClick= (cartId) =>{
        history.push(`/Cart/${cartId}`);
    }
    

    var [product , setProduct] = useState([])
    

    useEffect(()=>{
        fetch('https://blooming-gorge-87666.herokuapp.com/products')
        .then(res => res.json())
        .then(data => setProduct(data))
        
    },[])

   return (
        <div className="row d-flex justify-content-around">
            
            {
                product.map( event =>   
                    
                <div className="product-style col-lg-2 col-md-4">
                    <img style={{height:'200px'}} src={event.imageURL} alt=""/>
                    
                    <h5>{event.name}</h5>
                    <h5>Price {event.price} ৳</h5>
                    {/* <Cart information={event}></Cart> */}
                    <button onClick={()=>handleClick(event.id)}  className="btn btn-danger text-light">Order Now</button>
                    
                </div> 
                )
            }
        </div>
    );
};

export default Products;